import { Result, Row } from "antd";
import React from "react";

const ThankYouPage = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Result
        status="success"
        title="Reporte Completado"
        subTitle="El reporte se ha completado satisfactoriamente."
      />
    </div>
  );
};

export default ThankYouPage;
